import React from 'react';

export const Twitter = ({}) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36">
    <path d="M35 8.452c-1.214.53-2.519.886-3.889 1.046a6.681 6.681 0 002.977-3.677 13.716 13.716 0 01-4.3 1.613 6.818 6.818 0 00-4.941-2.1c-4.371 0-7.583 4.005-6.596 8.162A19.34 19.34 0 014.298 6.55c-1.774 2.988-.92 6.896 2.094 8.875a6.837 6.837 0 01-3.065-.832c-.074 3.08 2.174 5.96 5.43 6.602a6.908 6.908 0 01-3.058.113c.86 2.641 3.36 4.562 6.325 4.616C9.178 28.116 5.592 29.095 2 28.679a19.425 19.425 0 0010.379 2.986c12.57 0 19.672-10.423 19.243-19.772A13.648 13.648 0 0035 8.452z" />
  </svg>
);
